/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { Box, Button, CircularProgress, IconButton, LinearProgress, Switch, TextField, Tooltip } from '@mui/material';
import { colors } from '../../../utils';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
import Table from '../../../components/table/Table';
import { setAllGovNews } from '../../../redux/slices/posts/posts';
import { useLocation } from 'react-router-dom';
import { successNotify } from '../../../utils/helper';
import EditIcon from '@mui/icons-material/Edit';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import DeleteIcon from '@mui/icons-material/Delete';
import { setAboutUs } from '../../../redux/slices/aboutus/aboutus';
import ReadMoreReact from "read-more-react"
import moment from 'moment';
import Editor from 'react-simple-wysiwyg';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';

const AboutUs = () => {

	const dispatch = useDispatch();
	const location = useLocation();

	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { aboutus } = useSelector((state) => state?.aboutus);

	const { colorWhite, colorPrimary, colorGreenGradient } = colors;

	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [isLoadingImg, setIsLoadingImg] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);

	const [isLoadingDoc, setIsLoadingDoc] = useState(false);

	const [formData, setFormData] = useState({
		title: '',
		description: '',
		image: '',
	});
	// let sendId = location.pathname === "/corporate-governance-library/legal-and-regulatory/posts" ? 1 : 2;


	const getAboutUs = async () => {
		setIsLoading(true)
		try {

			await Api.get(`${endPoints?.aboutUs?.fetch}/all`, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAboutUs(
							response?.data?.data?.about?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								title: d?.title,
								description: d?.description,
								img: d?.img,
								dt: d?.dt,
								creator_id: d?.creator_id,
								creator_name: d?.creator_name,
								is_enabled: d?.is_enabled,
							})
							),
						),
					);
					setIsLoading(false)
				})
				.catch((error) => {
				});
		} catch (err) {
		}
	};



	const handleCloseModal = () => {
		setIsEditing(false)
		setOpenModal(false)
		setFormData({ title: '', description: '', img: '' })

	};
	const handleCloseDeleteModal = () => {
		setFormData({ title: '', description: '', img: '' })
		setOpenDeleteModal(false)
	};

	const handleEditModal = (val) => {
		setIsEditing(true)
		setOpenModal(val)
		setFormData({ id: val.id, title: val.title, description: val.description, img: val.img })
	};

	const handleOpenDeleteModal = (val) => {
		setFormData({ id: val.id })
		setOpenDeleteModal(true)
	};

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const handleSwitchClick = (event) => {
		event.stopPropagation();
	};
	const handleChangeTableSwitch = async (event, val) => {

		const { title, description, img, id } = val;
		let data1 = {
			title, description, img, id,
			is_enabled: event.target.checked,
		};

		// const data = {
		// 	...data1,
		// 	creator_id: userId,
		// };

		// await Api.post(endPoints?.aboutUs?.update, data, {
		// 	headers: {
		// 		'xt-user-token': null
		// 	}
		// })
		// 	.then((response) => {
		// 		handleCloseModal();
		// 		successNotify("About Us Status Updated Successfully")
		// 		getAboutUs();
		// 	})
		// 	.catch((error) => {

		// 	});
		try {

			await Api.post(endPoints?.aboutUs?.delete, {
				id: id,
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					handleCloseDeleteModal();
					successNotify("Status Updated Successfully")
					getAboutUs();

				})
				.catch((error) => {

				});

		} catch (err) {
		}

	};


	const handleImageUpload = (event) => {
		setIsLoadingImg(true)
		if (event.target.files.length > 0) {
			let formData = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formData.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null
				}
			})
				.then((response) => {
					setIsLoadingImg(false)
					setFormData((prevState) => ({
						...prevState,
						img: response.data.data.link,
					}));
					successNotify("Image Uploaded Successfully")

				})
				.catch((error) => {
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});

			// setErrMsg('Login Failed');

		}
	};


	const handleSubmit = async () => {
		setIsLoadingModal(true)

		if (!isEditing) {

			try {

				const data = {
					...formData,
					creator_id: userId,
					is_enabled: 'false'
				};

				await Api.post(endPoints?.aboutUs?.create, data, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						successNotify("About Us Created Successfully")
						getAboutUs();
						setIsLoadingModal(false)
					})
					.catch((error) => {

					});
			} catch (err) {
			}

		} else {

			try {

				const data = {
					...formData,
					creator_id: userId,
					is_enabled: 'true'
				};

				await Api.post(endPoints?.aboutUs?.update, data, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						successNotify("About Us Updated Successfully")
						getAboutUs();
						setIsLoadingModal(false)
					})
					.catch((error) => {

					});
			} catch (err) {
			}


		}
	};

	const handleDelete = async () => {
		try {

			await Api.post(endPoints?.aboutUs?.delete, {
				...formData
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					handleCloseDeleteModal();
					successNotify("About Us Deleted Successfully")
					getAboutUs();

				})
				.catch((error) => {

				});

		} catch (err) {
		}
	};


	const column = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		{
			title: 'Title',
			field: 'title',
			render: (rowData) => <h4 className='font-face-R'>{
				rowData?.title?.length > 15 ?
					<ReadMoreReact
						text={rowData?.title}
						min={10}
						ideal={15}
						max={rowData?.title?.length}
						readMoreText="Read More"
					/> : rowData?.title}</h4>,
		},
		{
			title: 'Description',
			field: 'description',
			width: "10%",
			render: (rowData) => <h4 className='font-face-R'><td dangerouslySetInnerHTML={{ __html: rowData?.description.substring(0, 50) + "..." }} /></h4>
			// rowData?.description?.length > 10 ?
			// <ReadMoreReact
			// 	text={<td dangerouslySetInnerHTML={{ __html: rowData?.description }} />}
			// 	min={10}
			// 	ideal={15}
			// 	max={rowData?.description?.length}
			// 	readMoreText="Read More"
			// /> : rowData?.description}</h4>,
		},
		{
			title: 'Image',
			field: 'img',
			render: (rowData) => rowData?.img ? <img src={rowData?.img} height='60' width='60' /> : <NoAccountsIcon />,
		},
		{
			title: 'Creator',
			field: 'creator_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.creator_name}</h4>,
		},
		{
			title: 'Date',
			field: 'dt',
			render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
		},
		{
			title: 'Status',
			field: 'enabled',
			render: (rowData) =>
				<Switch onClick={handleSwitchClick} onChange={(event) => handleChangeTableSwitch(event, rowData)} checked={rowData?.is_enabled} name='enabled' />,
		},
		{
			title: 'Edit',
			field: 'edit',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Edit'>
					<IconButton onClick={() => handleEditModal(rowData)} aria-label='Edit'>
						<EditIcon />
					</IconButton>
				</Tooltip>
			),
		},
		// {
		// 	title: 'Delete',
		// 	field: 'delete',
		// 	filtering: false,
		// 	render: (rowData) => (
		// 		<Tooltip title='Delete'>
		// 			<IconButton onClick={() => handleOpenDeleteModal(rowData)} aria-label='Delete'>
		// 				<DeleteIcon />
		// 			</IconButton>
		// 		</Tooltip>
		// 	),
		// },

	];

	useEffect(() => {
		getAboutUs()
	}, [])
	return (
		<>
			<Card margin='3rem 1.5rem' padding='3rem'>
				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<ButtonCom btnTitle='Add About Us' onClickHandler={() => setOpenModal(true)} />

					<TransitionsModal
						open={openModal}
						// handleOpen={handleOpenModal}
						handleClose={handleCloseModal}
						modalTitle={isEditing ? "Update About Us" : 'Add About Us'}
						isLoading={isLoadingModal}
					// submitHandler={leaveApprovedHandler}
					// submitDisabledBtn={leaveApprovedDis}
					>
						<Grid gtc='repeat(auto-fit, minmax(35rem, 1fr))' margin='2.5rem 0' padding='2rem'>

							{/* <MarginHandler width='100%'> */}
							<InputControl
								state={formData?.title}
								onChange={handleChange}
								// inputProps={{ maxLength: 150 }}
								label='Title'
								name='title'
							/>
							{/* </MarginHandler> */}
							{/* <MarginHandler width='100%'> */}
							{/* <InputControl
								state={formData?.description}
								onChange={handleChange}
								label='Description'
								name='description'
								multiline
								rows={6}
							/> */}
							<Editor value={formData?.description} name='description' onChange={handleChange} />
							{/* </MarginHandler> */}


							{isLoadingImg ?
								<CircularProgress sx={{ margin: "auto" }} color="success" />
								:
								<>
									<input
										accept=".jpeg, .jpg, .png"
										style={{ display: 'none' }}
										id="image-upload"
										type="file"
										onChange={(event) => handleImageUpload(event)}
									/>
									<label htmlFor="image-upload">
										<Button
											variant="contained"
											component="span"
											fullWidth
											color='success'
											style={{ fontSize: '1em' }}
										>
											Upload Image
										</Button>
									</label>
									{formData?.img &&
										<img height={100} style={{ margin: "auto" }} src={formData?.img} />
									}
								</>}
							{/* <MarginHandler width='50%'> */}




						</Grid>
						<MarginHandler mt="2rem">
							<Button
								color='primary'
								variant='contained'
								onClick={handleSubmit}
								style={{
									background: colorGreenGradient,
									fontSize: '1.6rem',
									textTransform: 'none',
									padding: '0.7rem 2rem',
									margin: "0 1em 1em 0",
									color: colorWhite,
									borderRadius: '0.5rem',
									float: "right"
								}}
								className='font-face-R'
								disabled={!formData.img || !formData.title || !formData.description}>

								{isEditing ? "Update About Us" : 'Add About Us'}
							</Button>
						</MarginHandler>
					</TransitionsModal>


				</Flex>

				{isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<Table
						columns={column}
						tableData={aboutus?.map((item) => ({ ...item }))}
						sorting
						columnsButton
						padding="3rem"
						showTitle
						// paginationType='normal'
						titleHeading="About Us"
						showToolbar={true}
						hidePagination
					/>
				}

				<DeleteModal
					open={openDeleteModal}
					handleClose={handleCloseDeleteModal}
					handleDelete={handleDelete}
				/>
			</Card>
		</>
	);
};

export default AboutUs;
